import React, { useRef } from "react";
import { MDBContainer, MDBRow, MDBCol } from "mdb-react-ui-kit";
import { Link } from "react-router-dom";
import { scroller } from "react-scroll";

const ProductsDropdown = () => {
  const dropdownRef = useRef(null);
  const dropdownButtonRef = useRef(null);

  const toggleDropdown = () => {
    dropdownRef.current.style.display =
      dropdownRef.current.style.display === "block" ? "none" : "block";
    setPosition();
  };

  const setPosition = () => {
    const dropdown = dropdownRef.current;
    const button = dropdownButtonRef.current;
    if (dropdown && button) {
      const rect = button.getBoundingClientRect();
      dropdown.style.top = `${rect.bottom + window.scrollY}px`;
      dropdown.style.left = `${rect.left + window.scrollX}px`;
    }
  };

  const scrollToElement = (sectionName) => {
    setTimeout(() => {
      scroller.scrollTo(sectionName, {
        duration: 100,
        smooth: "easeInOutQuart",
        offset: 0,
      });
    }, 100);
    if (dropdownRef.current) {
      dropdownRef.current.style.display = "none";
    }
  };

  return (
    <div>
      <div className="dropdown-content" ref={dropdownRef}>
        <MDBContainer
          class="bg-[#132043] rounded-md"
          className="absolute text-center text-md-start mt-5"
        >
          <MDBRow className="mt-3">
            <MDBCol md="12" lg="12" xl="12" className="mx-auto mb-4">
              <div className="industries-column">
                <p>
                  <Link
                    to="/EmbeddedP"
                    onClick={() => scrollToElement("Embedded")}
                  >
                    Embedded
                  </Link>
                </p>
                <p>
                  <Link to="/RFP" onClick={() => scrollToElement("RF")}>
                    RF & Microwave
                  </Link>
                </p>
                <p>
                  <Link
                    to="/AutonomousP"
                    onClick={() => scrollToElement("Autonomous")}
                  >
                    Autonomous
                  </Link>
                </p>
                <p>
                  <Link
                    to="/ElectromechanicalP"
                    onClick={() => scrollToElement("Electromechanical")}
                  >
                    Electromechanical
                  </Link>
                </p>
                <p>
                  <Link
                    to="/SolutionP"
                    onClick={() => scrollToElement("Electromechanical")}
                  >
                    Systems & Solutions
                  </Link>
                </p>
              </div>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </div>
    </div>
  );
};

export default ProductsDropdown;
